import throttle from 'lodash/throttle';
import { createRoot } from 'react-dom/client';

import { appShell } from '@savgroup-front-common/core/helpers';
import { generateUserManager } from '@savgroup-front-common/core/services/userManager';
import '@/helpers/localMoment';
import configureStoreAndHistory from '@/store/configureStore';
import { saveState } from '@/store/localStorage';
import '@/view/wdyr';

// eslint-disable-next-line import-x/extensions
import '@savgroup-front-common/primitive/globals.css';
import '../datadog.config';

import { AuthConfiguration } from './configuration';
import { fetchAuthorityUrl } from './helpers';
import App from './view/app/App';

async function getUserManager() {
  await fetchAuthorityUrl();

  return { userManager: generateUserManager(AuthConfiguration) };
}

getUserManager().then(({ userManager }) => {
  const { store } = configureStoreAndHistory();

  store.subscribe(() => {
    throttle(() => {
      saveState(store.getState());
    }, 1000);
  });

  appShell({
    userManager,
    render: () => {
      const container = document.getElementById('root');

      if (!container) {
        throw new Error('Root container "#root" was not found in the document');
      }

      const root = createRoot(container);

      root.render(<App store={store} />);
    },
  })
    // eslint-disable-next-line no-console
    .then(() => console.info('App launched with success.'))
    // eslint-disable-next-line no-console
    .catch((e) => console.error('App failed to launch.', e));
});
